import { fetch } from '@/api/index'
import { getToken } from '@/utils/auth'

const state = {
  projectArr: [],   // 项目
  departmentArr: [],    // 部门
  roleArr: [],   // 角色
  languageList: [
    {
      name: '中文',
      value: 'zh'
    },
    {
      name: 'English',
      value: 'en'
    }
  ],
  sexTypeArr: [], // 性别类型
  roleTypeArr: [], // 角色类型
  areaLevelSelectItem: [], // 地区级别
  webConfig: {}, // 页面配置数据
  frontConfig: {}, // 非公开数据,登录之后才能获取
  projectIdList: [] // 使用端的下拉选项
}

const mutations = {
  SET_PROJECTARR: (state, arr) => {
    state.projectArr = arr
  },
  SET_DEPARTMENTARR: (state, arr) => {
    state.departmentArr = arr
  },
  SET_ROLEARR: (state, arr) => {
    state.roleArr = arr
  },
  SET_SEXTYPEARR(state, arr) {
    state.sexTypeArr = arr
  },
  SET_ROLETYPEARR(state, arr) {
    state.roleTypeArr = arr
  },
  SET_AREALEVELSELECTITEM(state, arr) {
    state.areaLevelSelectItem = arr
  },
  SET_WEBCONFIG(state, val) {
    state.webConfig = val
  },
  SET_FRONTCONFIG(state, val) {
    state.frontConfig = val
  },
  SET_PROJECTIDLIST(state, val) {
    state.projectIdList = val
  }
}

const actions = {
  async setProjectArr({ commit }) {
    if (!getToken()) return
    const data = await fetch('/api/auth/project/get_list', {}, 'get')
    if (data.code === 200) {
      commit('SET_PROJECTARR', data.data)
    }
  },
  async setDepartmentArr({ commit }) {
    const data = await fetch('/api/auth/department/get_department_list', {}, 'get')
    if (data.code === 200) {
      commit('SET_DEPARTMENTARR', data.data)
    }
  },
  async setRoleArr({ commit }) {
    const data = await fetch('/api/auth/role/get_role_list', {}, 'get')
    if (data.code === 200) {
      commit('SET_ROLEARR', data.data)
    }
  },
  // 性别类型
  async setsexTypeArr({ commit }) {
    const data = await fetch('/api/user/user/sexType', {}, 'get')
    if (data.code === 20000) {
      commit('SET_SEXTYPEARR', data.data)
    }
  },
  // 角色类型
  async setRoleTypeArr({ commit }, params = {}) {
    const data = await fetch('/api/user/role/roleType', {
      rootPage: params.rootPage || 0 // 在哪里使用：0-默认值 1-系统职务管理
    }, 'get')
    if (data.code === 20000) {
      commit('SET_ROLETYPEARR', data.data)
    }
  },
  // 获取地区级别下拉选项
  async setAreaLevelSelectItem({ commit }) {
    const data = await fetch('/api/user/area/getAreaLevelSelectItem', {}, 'get')
    if (data.code === 20000) {
      commit('SET_AREALEVELSELECTITEM', data.data)
    }
  },
  // 获取页面配置数据
  async fetchOpenData({ commit }) {
    const data = await fetch('/api/user/frontConfig/open/data', {}, 'get')
    if (data.code === 20000) {
      commit('SET_WEBCONFIG', data.data)
    }
  },
  // 获取非公开数据,登录之后才能获取
  async fetchFrontConfigData({ commit }) {
    const data = await fetch('/api/user/frontConfig/data', {}, 'get')
    if (data.code === 20000) {
      commit('SET_FRONTCONFIG', data.data)
    }
  },
  // 获取项目和使用端的列表
  async fetchProjectTargetSelect({ commit }) {
    const { code, data } = await fetch(`/api/user/project/findAllBaseProjectWithChild`, {}, 'get')
    if (code === 20000) {
      const temp = (Array.isArray(data) ? data : []).map(item => ({
        ...item,
        disabled: !(Array.isArray(item.children) && item.children.length > 0 && Object.prototype.toString.call(item.children[0]) === '[object Object]' && Object.prototype.hasOwnProperty.call(item.children[0], 'value'))
      }))

      commit('SET_PROJECTIDLIST', temp.filter(item => !item.disabled))
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
